import {useCallback} from 'react'
import {useAppDispatch} from '../../../components/hooks/useAppDispatch'
import {useAppSelector} from '../../../components/hooks/useAppSelector'
import {FeatureModelCode} from '../../../models/FeatureModel'
import {actions} from '../AuthRedux'

export const useAuth = () => {
  const dispatch = useAppDispatch()
  const auth = useAppSelector((state) => state.auth)
  const user = auth.user.data?.user
  const isLoading = auth.user.status === 'pending'
  const logout = useCallback(() => {
    dispatch(actions.logout())
  }, [dispatch])

  const userCanManageFeature = useCallback(
    (featureCode: FeatureModelCode | FeatureModelCode[]) => {
      if (user) {
        if (user.isAdmin) {
          return true
        }
        if (user.role?.features) {
          const features = user.role.features
          if (Array.isArray(featureCode)) {
            return featureCode.some(code => 
              features?.some(feature => feature.code === code && feature.rw)
            )
          } else {
            return features?.some(feature => feature.code === featureCode && feature.rw)
          }
        }
      }
      return false
    },
    [user]
  )

  const userCanReadFeature = useCallback(
    (featureCode: FeatureModelCode | FeatureModelCode[]) => {
      if (user) {
        if (user.isAdmin) {
          return true
        }
        if (user.role?.features) {
          const features = user.role.features
          if (Array.isArray(featureCode)) {
            return featureCode.some(code => 
              features?.some(feature => feature.code === code)
            )
          } else {
            return features.some((feature) => feature.code === featureCode)
          }
        }
      }
      return false
    },
    [user]
  )

  return {user, isLoading, logout, userCanManageFeature, userCanReadFeature}
}
